import { render, staticRenderFns } from "./Konto.vue?vue&type=template&id=ff9b3e28&scoped=true&"
import script from "./Konto.vue?vue&type=script&lang=js&"
export * from "./Konto.vue?vue&type=script&lang=js&"
import style0 from "./Konto.vue?vue&type=style&index=0&id=ff9b3e28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9b3e28",
  null
  
)

component.options.__file = "Konto.vue"
export default component.exports